namespace GeniuzPOS.Purchase {
    export interface PoPo05DtPendingPIforIrRow {
        Id?: number;
        SysDocNo?: string;
        UseFg?: number;
        WhsId?: string;
        LineItemNo?: number;
        SkuCode?: string;
        SkuDesc?: string;
        PurUnitPrice?: number;
        Qty?: number;
        PurUnit?: string;
        DiscAmt?: number;
        ItemAmt?: number;
        Remark?: string;
    }

    export namespace PoPo05DtPendingPIforIrRow {
        export const idProperty = 'Id';
        export const nameProperty = 'SysDocNo';
        export const localTextPrefix = 'Purchase.PoPo05DtPendingPIforIr';
        export const lookupKey = 'Purchase.PoPo05DtPendingPIforIr';

        export function getLookup(): Q.Lookup<PoPo05DtPendingPIforIrRow> {
            return Q.getLookup<PoPo05DtPendingPIforIrRow>('Purchase.PoPo05DtPendingPIforIr');
        }
        export const deletePermission = '*';
        export const insertPermission = '*';
        export const readPermission = '*';
        export const updatePermission = '*';

        export declare const enum Fields {
            Id = "Id",
            SysDocNo = "SysDocNo",
            UseFg = "UseFg",
            WhsId = "WhsId",
            LineItemNo = "LineItemNo",
            SkuCode = "SkuCode",
            SkuDesc = "SkuDesc",
            PurUnitPrice = "PurUnitPrice",
            Qty = "Qty",
            PurUnit = "PurUnit",
            DiscAmt = "DiscAmt",
            ItemAmt = "ItemAmt",
            Remark = "Remark"
        }
    }
}
